import lodash from "lodash";
import { createLoading } from "../../../../../../utils/loading";
import i18n from "../../../../../../i18n";
import { createButtonCreate } from "../../../../../../utils/button";
import { conditionFormChecker, initUseForm, putField } from "../../../../../../utils/form";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { validateError } from "../../../../../../utils/validate";
import { createPage, createManageSelect /*, createManageDelete*/ } from "../../../../../../utils/page";
import {
    createFieldInput,
    createFieldInputNumber,
    createFieldSelect,
} from "../../../../../../components/input/template-builder/template-builder.logic";
import {
    callToolUnit,
    createForm as createFormFishingTool,
    generateListMonth,
    createRules as createRulesFishingTool,
    setQtyBySubQty,
} from "../../../fishing-tool/fishing-tool.logic";
import { createConditionForm } from "../fishing-tool/fishing-tool.condition";
import { callWidthUnit } from "../../../fishing-tool/fishing-tool.logic";
import { filter } from "../../../../../../utils/search";
import { modalStyleForm } from "../../../../../../utils/constant";
import { addModal, removeModal } from "../../../../../../app.logic";
import store from "../../../../../../store";
//import { notification } from "ant-design-vue";

export const { isLoading, setIsLoading } = createLoading();
const FishingToolForm = defineAsyncComponent(() => import("./FishingToolForm"));

export const callFishingTool = ({ searchQuery, refParentId, refParentOperator = "=", where = [], checkLimit = false }) => {
    if (searchQuery) {
        where.push({ name: "nameTh", type: "String", operator: "like", value: searchQuery });
    }
    if (checkLimit) {
        where.push({ name: "isCountLimitRequest", type: "Boolean", operator: "=", value: false });
    }
    return store
        .dispatch("resource/v1/master/fishingTool/search", {
            criteria: {
                select: ["**"],
                page: 0,
                size: 100000,
                where: [
                    ...where,
                    { name: "isActive", type: "Boolean", operator: "=", value: true },
                    { name: "refParent.id", type: "UUID", operator: refParentOperator, value: refParentId },
                ],
                sort: [{ name: "nameTh", type: "ASC" }],
                children: [],
            },
        })
        .then((page) => page.data);
};

export const onClickEdit = ({ record, props, data }) => {
    const { menuContext, viewOnly, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    record.isSave = true;
    openModalForm({
        props: {
            menuContext,
            viewOnly,
            setAppPageHeader: false,
            form: record,
            itemsList: items,
        },
        modelRef,
    });
};

// export const onClickDelete = ({ record, props, data }) => {
//     const { itemsKey } = props;
//     const { useForm } = data;
//     const { modelRef } = useForm;
//     const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
//     if (record.refOriginal) {
//         record.isSave = true;
//         record.isCancel = true;
//         record.isChange = false;
//     } else if (record.id) {
//         record.isDelete = true;
//     } else {
//         lodash.remove(items, (item) => lodash.isEqual(item, record));
//     }
//     items?.forEach((record) => {
//         const promises = [onChangeColorCard({ record })];
//         Promise.all(promises).then(() => {
//             if (record.refOriginal) {
//                 modelRef.refOriginal?.fishingToolRequests?.forEach((originalRecord) => {
//                     if (record.refOriginal?.id === originalRecord.id) {
//                         originalRecord.color = record.color;
//                     }
//                 });
//             }
//         });
//     });
// };

export const conditionFishingTool = ({ modelRef }) => {
    return ![undefined, "draft", "waitModify"].includes(modelRef.refStatus?.key) || !["tool"].includes(modelRef.refChangeLicenseObjective?.key);
};

export const conditionListPageFishingTool = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    return [undefined, "draft", "waitModify"].includes(modelRef.refStatus?.key) && ["tool"].includes(modelRef.refChangeLicenseObjective?.key);
};

export const initData = ({ props, data }) => {
    const { itemsKey, menuContext, viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    items?.forEach((record) => {
        const promises = [onChangeColorCard({ record })];
        Promise.all(promises).then(() => {
            if (!"fishingToolRequests".includes(props.itemsKey)) {
                record.color = "backgroundColor: #bae7ff";
                modelRef.fishingToolRequests?.forEach((childrenRecord) => {
                    if (childrenRecord.refOriginal != null && record.id === childrenRecord.refOriginal?.id) {
                        record.color = childrenRecord.color;
                    }
                });
            }
        });
    });
    data.manages = [
        createManageSelect({ menuContext }),
        // createManageDelete({
        //     menuContext,
        //     confirm: ({ rowSelection }) => ({
        //         content: rowSelection.selectedRows.map((d) => d.refFishingTool.key).join(", "),
        //         okType: "danger",
        //     }),
        //     onClick: ({ rowSelection }) => {
        //         rowSelection.selectedRows?.forEach((d) => {
        //             d.isCancel = true;
        //         });
        //     },
        // }),
    ];
    data.manageExtras = [
        {
            render: () =>
                createButtonCreate({
                    onClick: () =>
                        openModalForm({
                            props: {
                                menuContext,
                                viewOnly,
                                setAppPageHeader: false,
                                itemsList: items,
                            },
                            items,
                            itemsKey,
                            modelRef,
                        }),
                    options: {
                        text: i18n.global.t("button.create"),
                        disabled: !"fishingToolRequests".includes(itemsKey) || viewOnly || conditionFishingTool({ modelRef }),
                    },
                }),
            visible: () => true,
        },
    ];
    data.page = createPage({ data: items });
};

export const initForm = ({ props, data, refs }) => {
    data.form = createFormFishingTool();
    data.rules = createRulesFishingTool({ data });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createFields({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    loadForm({ props, data, refs });
};

export const createFields = ({ props, data, key }) => {
    const { viewOnly, usedFishingTools, maximumWidth } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const listMonth = generateListMonth();

    let countLimit = 3;
    usedFishingTools?.forEach((item) => {
        if (item.refFishingTool.isCountLimitRequest) countLimit--;
    });
    let checkLimit = countLimit <= 0 ? true : false;
    let where = [];
    if (usedFishingTools?.map((d) => d.refFishingTool?.id).length) {
        where.push({ name: "id", type: "UUID", isNot: true, operator: "in", value: usedFishingTools?.map((d) => d.refFishingTool?.id) });
    }
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refFishingToolType`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.refFishingToolType")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refFishingToolType,
                            "onUpdate:value": (value) => {
                                model.refFishingToolType = value;
                                if (model.refFishingTool && model.refFishingTool.refParent?.id !== model.refFishingToolType?.id) {
                                    model.refFishingTool = null;
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callFishingTool({ searchQuery, refParentOperator: "=", refParentId: null }),
                            optLabel: "nameTh",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refFishingTool`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.refFishingTool")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refFishingTool,
                            "onUpdate:value": (value) => {
                                model.refFishingTool = value;
                                model.refUnitType = value.refFishingToolUnit;
                                model.refWidthType = value.refWidthUnit;
                                model.firstSubQty = null;
                                model.secondSubQty = null;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callFishingTool({
                                    searchQuery,
                                    refParentOperator: "=",
                                    refParentId: model.refFishingToolType?.id,
                                    checkLimit,
                                    where,
                                }),
                            optLabel: "nameTh",
                            allowClear: false,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) },
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}fishingToolName`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.fishingToolRequest.fishingToolName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.fishingToolName,
                            "onUpdate:value": (value) => (model.fishingToolName = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}firstSubQty`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.firstSubQty")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.firstSubQty,
                            "onUpdate:value": (value) => {
                                model.firstSubQty = value;
                                setQtyBySubQty({ model });
                            },
                            disabled: viewOnly,
                            comma: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}secondSubQty`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.secondSubQty")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.secondSubQty,
                            "onUpdate:value": (value) => {
                                model.secondSubQty = value;
                                setQtyBySubQty({ model });
                            },
                            disabled: viewOnly,
                            comma: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}qty`,
                colProp: () => ({ xs: 24, md: 18, style: { paddingLeft: "2px !important" } }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
                label: () =>
                    `${i18n.global.t("model.fishingToolRequest.qty")}  ${
                        !model.refFishingTool?.maximumQty
                            ? ""
                            : i18n.global.t("model.fishingToolRequest.labels.maximumQty", { max: model.refFishingTool?.maximumQty })
                    }`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.qty,
                            "onUpdate:value": (value) => {
                                // if (model.refFishingTool?.maximumQty > 0 && value > model.refFishingTool?.maximumQty) {
                                //     model.qty = lodash.cloneDeep(model.refFishingTool?.maximumQty)
                                // } else {
                                model.qty = value;
                                //}
                            },
                            disabled: viewOnly,
                            comma: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refUnitType`,
                colProp: () => ({ xs: 24, md: 6 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refUnitType,
                            "onUpdate:value": (value) => (model.refUnitType = value),
                            disabled: true,
                            list: callToolUnit,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}width`,
                colProp: () => ({ xs: 24, md: 18, style: { paddingLeft: "2px !important" } }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 11 }, wrapperCol: { xs: 24, md: 13 } }),
                label: () =>
                    `${i18n.global.t("model.fishingToolRequest.width")}  ${
                        !model.refFishingTool?.maximumWidth
                            ? ""
                            : i18n.global.t("model.fishingToolRequest.labels.maximumWidth", { max: maximumWidth ?  maximumWidth: model.refFishingTool?.maximumWidth })
                    }`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.width,
                            "onUpdate:value": (value) => {
                                // if (model.refFishingTool?.maximumWidth > 0 && value > model.refFishingTool?.maximumWidth) {
                                //     model.width = lodash.cloneDeep(model.refFishingTool?.maximumWidth)
                                // } else {
                                model.width = value;
                                //}
                            },
                            disabled: viewOnly,
                            comma: true,
                            allowPrecision: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refWidthType`,
                colProp: () => ({ xs: 24, md: 6 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refWidthType,
                            "onUpdate:value": (value) => (model.refWidthType = value),
                            disabled: true,
                            list: callWidthUnit,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}monthStartFishing`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.monthStartFishing")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: listMonth.find((month) => month.nameTh === model.monthStartFishing),
                            "onUpdate:value": (value) => {
                                model.monthStartFishing = value.nameTh;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                filter({
                                    list: listMonth,
                                    where: [
                                        { name: "nameTh", operator: "like", value: searchQuery },
                                        { logic: "OR", name: "nameEn", operator: "like", value: searchQuery },
                                    ],
                                    sort: [{ name: "seq", type: "ASC" }],
                                }),
                            optKey: "nameTh",
                            optLabel: "nameTh",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}monthEndFishing`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingToolRequest.monthEndFishing")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: listMonth.find((month) => month.nameTh === model.monthEndFishing),
                            "onUpdate:value": (value) => {
                                model.monthEndFishing = value.nameTh;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                filter({
                                    list: listMonth,
                                    where: [
                                        { name: "nameTh", operator: "like", value: searchQuery },
                                        { logic: "OR", name: "nameEn", operator: "like", value: searchQuery },
                                    ],
                                    sort: [{ name: "seq", type: "ASC" }],
                                }),
                            optKey: "nameTh",
                            optLabel: "nameTh",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
        ],
    });
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then((page) => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

// export const openModalForm = ({ props, items, modelRef }) => {
//     const refs = reactive({ form: null });
//     const {form} = props
//     if(form){
//         props.isNotChangeType = true
//     }
//     let usedFishingTools = !items
//         ? props.itemsList?.filter((d) => !d.isDelete && (d.id != props.form?.id || d._id != props.form?._id))
//         : items?.filter((d) => !d.isDelete);
//     const options = addModal({
//         bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
//             width: "50%",
//             okButtonProps: { disabled: props.viewOnly },
//             header: i18n.global.t("model.button.create"),
//             onOk: () => {
//                 refs.form.callOnClickModalOk().then((record) => {
//                     Promise.all([calUseFishingTool({ items, record })]).then((res) => {
//                         if (items && res[0]) {
//                             const itemsHaveOne = items?.find((d) => d.refFishingTool?.id === record.refFishingTool?.id);
//                             if (itemsHaveOne) {
//                                 record.isChange = itemsHaveOne.refOriginal ? true : false;
//                                 //record.isCancel = false;
//                                 lodash.merge(itemsHaveOne, record);
//                             } else {
//                                 const isAddItem = res[0];
//                                 if (isAddItem === true) items.push(record);
//                             }
//                         }
//                     }).then(()=>{
//                         items?.forEach((record) => {
//                             const promises = [onChangeColorCard({ record })];
//                             Promise.all(promises).then(() => {
//                                 if (record.refOriginal) {
//                                     modelRef.refOriginal?.fishingToolRequests?.forEach((originalRecord) => {
//                                         if (record.refOriginal?.id === originalRecord.id) {
//                                             originalRecord.color = record.color;
//                                         }
//                                     });
//                                 }
//                             });
//                         });
//                         // Promise.all([onChangeColorCard({ record })]).then(() => {
//                         //     modelRef?.refOriginal?.fishingToolRequests?.forEach((originalRecord) => {
//                         //         if (originalRecord.id === record.refOriginal?.id) {
//                         //             originalRecord.color = record.color;
//                         //         }
//                         //     });
//                         // });
//                     })
//                     options.bind.onCancel();
//                 });
//             },
//         }),
//         render: () => (
//             <FishingToolForm
//                 ref={(e) => {
//                     if (e) refs.form = e;
//                 }}
//                 {...props}
//                 usedFishingTools={usedFishingTools}
//             ></FishingToolForm>
//         ),
//     });
//     return options;
// };

export const openModalForm = ({ props, items, callback, modelRef }) => {
    const refs = reactive({ form: null });
    let usedFishingTools = !items
        ? props.itemsList?.filter((d) => !d.isDelete && (d.id != props.form?.id || d._id != props.form?._id))
        : items?.filter((d) => !d.isDelete);
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            width: "50%",
            okButtonProps: { disabled: props.viewOnly },
            header: i18n.global.t("model.button.create"),
            onOk: () => {
                refs.form.callOnClickModalOk().then((record) => {
                    callback?.();
                    //record.isChange = record.refOriginal ? true : false;
                    if(record.refOriginal) {
                        if(record.qty === '') record.qty = null;
                        if(record.firstSubQty === '') record.firstSubQty = null;
                        if(record.secondSubQty === '') record.secondSubQty = null;
                        if(record.width === '') record.width = null;
                        const checks = [];
                        checks.push(record.refOriginal.refFishingToolType?.id !== record.refFishingToolType?.id);
                        checks.push(record.refOriginal.refFishingTool?.id !== record.refFishingTool?.id);
                        checks.push(record.refOriginal.refUnitType?.id !== record.refUnitType?.id);
                        checks.push(record.refOriginal.refWidthType?.id !== record.refWidthType?.id);
                        checks.push((record.refOriginal.qty?.toString() || '0.0') !== (record.qty?.toString() || '0.0'));
                        checks.push((record.refOriginal.firstSubQty?.toString() || '0.0') !== (record.firstSubQty?.toString() || '0.0'));
                        checks.push((record.refOriginal.secondSubQty?.toString() || '0.0') !== (record.secondSubQty?.toString() || '0.0'));
                        checks.push((record.refOriginal.width?.toString() || '0.0') !== (record.width?.toString() || '0.0'));
                        checks.push(record.refOriginal.monthStartFishing !== record.monthStartFishing);
                        checks.push(record.refOriginal.monthEndFishing !== record.monthEndFishing);
                        record.isChange = checks.includes(true);
                    }
                    if (items) {
                        items.push(record);
                    } else {
                        //record.isChange = record.refOriginal ? true : false;
                        lodash.merge(props.form, record);
                    }
                    props.itemsList?.forEach((record) => {
                        const promises = [onChangeColorCard({ record })];
                        Promise.all(promises).then(() => {
                            if (record.refOriginal) {
                                modelRef.refOriginal?.fishingToolRequests?.forEach((originalRecord) => {
                                    if (record.refOriginal?.id === originalRecord.id) {
                                        originalRecord.color = record.color;
                                    }
                                });
                            }
                        });
                    });

                    options.bind.onCancel();
                });
            },
            onCancel: () => {
                callback?.();
                removeModal({ options });
            },
        }),
        render: () => (
            <FishingToolForm
                ref={(e) => {
                    if (e) refs.form = e;
                }}
                {...props}
                usedFishingTools={usedFishingTools}
            ></FishingToolForm>
        ),
    });
    return options;
};

// export const calUseFishingTool = ({ items, record }) => {
//     let countLimit = 3;
//     items?.forEach((item) => {
//         if (item.refFishingTool.isCountLimitRequest) countLimit--;
//     });
//     const itemsHaveOne = items?.find((d) => d.refFishingTool?.id === record.refFishingTool?.id);
//     const itemsNotMatch = items?.find((d) => d.refFishingTool?.id === record.refFishingTool?.id);
//     if (itemsHaveOne || (!itemsNotMatch && record.refFishingTool?.isCountLimitRequest)) countLimit--;
//     if (countLimit < 0) {
//         notification["error"]({ message: i18n.global.t("views.notification.userFishingTools") });
//         return null;
//     }
//     return true;
// };

export const onChangeColorCard = ({ record }) => {
    let color = "#bae7ff"; //ฟ้า
    if (!record.refOriginal) {
        //เขียว
        color = "#a0d911";
    } else if (record.refOriginal && record.isChange) {
        //เหลือง
        color = "#fadb14";
    }
    record.color = `backgroundColor: ${color}`;
};
